import { render, staticRenderFns } from "./categoryEdit.vue?vue&type=template&id=2e781b80&scoped=true&"
import script from "./categoryEdit.vue?vue&type=script&lang=js&"
export * from "./categoryEdit.vue?vue&type=script&lang=js&"
import style0 from "./categoryEdit.vue?vue&type=style&index=0&id=2e781b80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e781b80",
  null
  
)

export default component.exports